<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        v-if="$ability.can('Adicionar', 'Inadimplencia')"
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogFormInadimplencia.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Nova Faixa de Inadimplência
      </v-btn>
      <DialogFormInadimplencia @created="create($event)" ref="dialogFormInadimplencia" />
      <v-form ref="formBusca">
        <v-row dense>
          <v-col cols="12" sm="12" md="5">
            <SelectEmpresa
              :multiple="true"
              @onChanged="filtro.empresas = $event"
              @onEmpresas="empresas = $event"
              return-object
            />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-select label="Papel" v-model="filtro.papel" :items="['Vendedor', 'Supervisor']">
              <template v-slot:selection="{ item }">
                <v-chip>
                  <span>{{ item }}</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="12" class="d-flex align-center justify-center">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Inadimplencia from "@/services/inadimplencia";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "FiltroInadimplencia",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogFormInadimplencia: () => import("./DialogFormInadimplencia.vue")
  },

  data() {
    return {
      serviceInadimplencia: new Inadimplencia(),
      filtro: {
        empresas: []
      },
      empresas: []
    };
  },

  computed: {
    ...mapGetters("inadimplencia", ["getInadimplencia"])
  },

  methods: {
    ...mapActions({
      actionInadimplencia: "inadimplencia/actionInadimplencia"
    }),

    async buscar() {
      if (this.$refs.formBusca.validate()) {
        try {
          const dados = await this.serviceInadimplencia.getByEmpresaPapel(
            this.filtro,
            this.empresas
          );

          this.actionInadimplencia(dados);
          if (dados.length === 0) {
            this.$toast.warning("Nada foi encontrado");
          }
        } catch (error) {
          this.$toast.error(error);
        }
      }
    },

    create(inadimplencia) {
      if (this.getInadimplencia === null) {
        this.actionInadimplencia([
          {
            id: inadimplencia.id,
            empresa: inadimplencia.empresa,
            dataCriacao: inadimplencia.dataCriacao,
            apelido: inadimplencia.apelido,
            faixaInadimplencia1: inadimplencia.faixaInadimplencia1,
            faixaInadimplencia2: inadimplencia.faixaInadimplencia2,
            papel: inadimplencia.papel
          }
        ]);
      } else {
        this.actionInadimplencia(
          this.getInadimplencia.concat(
            ...[
              {
                id: inadimplencia.id,
                empresa: inadimplencia.empresa,
                dataCriacao: inadimplencia.dataCriacao,
                apelido: inadimplencia.apelido,
                faixaInadimplencia1: inadimplencia.faixaInadimplencia1,
                faixaInadimplencia2: inadimplencia.faixaInadimplencia2,
                papel: inadimplencia.papel
              }
            ]
          )
        );
      }
    }
  },

  async mounted() {
    try {
      if (this.getInadimplencia.length === 0) {
        const response = await this.serviceInadimplencia.getAll();
        this.actionInadimplencia(response);
      }
    } catch (error) {
      this.$toast.error(`Erro ao buscar os dados`);
    }
  }
};
</script>

<style></style>
